import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  salesforceService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface SalesforcePairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function SalesforcePairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: SalesforcePairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="salesforce"
      displayName="Salesforce"
      description="Connect your Salesforce org so your assistant can read and update CRM records during conversations."
      features={[
        'Search accounts, contacts, leads, opportunities, and cases',
        'Answer questions across all your Salesforce data',
        'Create and update CRM records on your behalf',
        'Log calls and activities against the right record',
      ]}
      accentColor="sky"
      events={{
        modalOpened: OnboardingEvents.SALESFORCE_MODAL_OPENED,
        oauthStarted: OnboardingEvents.SALESFORCE_OAUTH_STARTED,
        connected: OnboardingEvents.SALESFORCE_CONNECTED,
        connectionFailed: OnboardingEvents.SALESFORCE_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.SALESFORCE_MODAL_CLOSED,
      }}
      service={salesforceService}
    />
  );
}
